// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       // Remove the results when they are no longer relevant for the new search term
//       // so they don't show up when the dropdown opens again
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     // Update the term asap, don't wait for the predictive search query to finish loading
//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);

//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
//       (element) => element.offsetParent !== null
//     );
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = '';

//     if (!moveUp && selectedElement) {
//       activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(' ', '-').toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
//       signal: this.abortController.signal,
//     })
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector('#shopify-section-predictive-search').innerHTML;
//         // Save bandwidth keeping the cache in all instances synced
//         this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
//           predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//         });
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           return;
//         }
//         this.close();
//         throw error;
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);






















class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.cachedMetafieldResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();

    const newSearchTerm = this.getQuery();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);

    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;

    if (currentButtonText) {
      if (previousTerm && currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
        return;
      }

      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );

    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  isCodeLikeSearch(query) {
  const value = String(query || '').trim();

  if (!value) return false;

  // PI-style code
  if (/^pi[\s\-_/]*\d+$/i.test(value)) {
    return true;
  }

  // Compact codes with multiple separators, e.g. BSB-185-TEST
  const separators = (value.match(/[\-_/]/g) || []).length;
  const hasLetter = /[a-z]/i.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpaces = /\s/.test(value);

  return hasLetter && hasNumber && !hasSpaces && separators >= 2;
}

normalizeCodeSearch(query) {
  if (!this.isCodeLikeSearch(query)) {
    return query;
  }

  return String(query)
    .replace(/[^a-z0-9]/gi, '')
    .toUpperCase();
}

  getSearchResults(searchTerm) {
    const requestTerm = this.normalizeCodeSearch(searchTerm);
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.injectMetafieldPredictiveResults(searchTerm);
      return;
    }

    fetch(
  `${routes.predictive_search_url}?q=${encodeURIComponent(requestTerm)}` +
  `&resources[type]=product,page` +
  `&resources[options][fields]=title,product_type,variants.title,vendor,tag` +
  `&section_id=predictive-search`,
  {
    signal: this.abortController.signal,
  }
)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });

        this.renderSearchResults(resultsMarkup);
        this.injectMetafieldPredictiveResults(searchTerm);
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }

        this.close();
        throw error;
      });
  }

async fetchMetafieldSearchIndex() {
  if (window.customMetafieldPredictiveIndex) {
    return window.customMetafieldPredictiveIndex;
  }

  const jsonEl = document.getElementById('biosb-global-search-index');

  if (!jsonEl) {
    console.warn('BIOSB global search index not found.');
    return [];
  }

  try {
    window.customMetafieldPredictiveIndex = JSON.parse(jsonEl.textContent);

    console.log(
      'BIOSB search index loaded:',
      window.customMetafieldPredictiveIndex.length
    );

    return window.customMetafieldPredictiveIndex;
  } catch (error) {
    console.warn('BIOSB search index JSON is invalid.', error);
    return [];
  }
}

  normalizeSearchValue(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/g, '');
}

productMatchesMetafield(product, searchTerm) {
  const query = this.normalizeSearchValue(searchTerm);

  if (!query) return false;

  const searchableValues = [
    product.title,
    product.clone,
    product.cs_catalog_number,
    product.catalog_number,
    product.pi_number,
    product.handle
  ]
    .filter(Boolean)
    .map((value) => this.normalizeSearchValue(value));

  return searchableValues.some((value) => value.includes(query));
}

  escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // async injectMetafieldPredictiveResults(searchTerm) {
  //   const queryKey = searchTerm.toLowerCase();

  //   let matchedProducts = [];

  //   if (this.cachedMetafieldResults[queryKey]) {
  //     matchedProducts = this.cachedMetafieldResults[queryKey];
  //   } else {
  //     const allProducts = await this.fetchMetafieldSearchIndex();

  //     matchedProducts = allProducts
  //       .filter((product) => this.productMatchesMetafield(product, searchTerm))
  //       .slice(0, 6);

  //     this.cachedMetafieldResults[queryKey] = matchedProducts;
  //   }

  //   if (!matchedProducts.length) return;

  //   const wrapper = this.querySelector('#predictive-search-results-groups-wrapper');

  //   if (!wrapper) return;

  //   const existingLinks = Array.from(wrapper.querySelectorAll('a[href]')).map((link) => link.getAttribute('href'));

  //   const uniqueProducts = matchedProducts.filter((product) => {
  //     return product.url && !existingLinks.includes(product.url);
  //   });

  //   if (!uniqueProducts.length) return;

  //   const productsGroup = wrapper.querySelector('.predictive-search__results-list') || wrapper.querySelector('ul');

  //   if (!productsGroup) return;

  //   const customItemsHtml = uniqueProducts.map((product, index) => {
  //     const safeTitle = this.escapeHtml(product.title);
  //     const safeUrl = this.escapeHtml(product.url);
  //     const safeImage = this.escapeHtml(product.image);

  //     return `
  //       <li
  //         id="predictive-search-option-metafield-${index}"
  //         class="predictive-search__list-item"
  //         role="option"
  //         aria-selected="false"
  //       >
  //         <a href="${safeUrl}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1">
  //           ${
  //             safeImage
  //               ? `<img class="predictive-search__image" src="${safeImage}" alt="${safeTitle}" width="50" height="50">`
  //               : ''
  //           }
  //           <div class="predictive-search__item-content predictive-search__item-content--centered">
  //             <p class="predictive-search__item-heading h5">${safeTitle}</p>
  //           </div>
  //         </a>
  //       </li>
  //     `;
  //   }).join('');

  //   productsGroup.insertAdjacentHTML('beforeend', customItemsHtml);
  // }

  async injectMetafieldPredictiveResults(searchTerm) {
  const queryKey = this.normalizeSearchValue(searchTerm);

  let matchedProducts = [];

  if (this.cachedMetafieldResults[queryKey]) {
    matchedProducts = this.cachedMetafieldResults[queryKey];
  } else {
    const allProducts = await this.fetchMetafieldSearchIndex();

    matchedProducts = allProducts
      .filter((product) => this.productMatchesMetafield(product, searchTerm))
      .slice(0, 6);

    this.cachedMetafieldResults[queryKey] = matchedProducts;
  }

  if (!matchedProducts.length) return;

  /*
   * Find the main predictive results container.
   */
  const resultsContainer = this.querySelector('#predictive-search-results');

  if (!resultsContainer) return;

  /*
   * Find/create the results groups wrapper.
   */
  let wrapper = resultsContainer.querySelector(
    '#predictive-search-results-groups-wrapper'
  );

  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.id = 'predictive-search-results-groups-wrapper';
    wrapper.className = 'predictive-search__results-groups-wrapper';

    const searchButton = resultsContainer.querySelector(
      '#predictive-search-option-search-keywords'
    );

    if (searchButton) {
      resultsContainer.insertBefore(wrapper, searchButton);
    } else {
      resultsContainer.prepend(wrapper);
    }
  }

  /*
   * Get URLs Shopify has already returned.
   * This prevents duplicate products.
   */
  const existingUrls = Array.from(
    wrapper.querySelectorAll('a[href]')
  ).map((link) => {
    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (e) {
      return link.getAttribute('href');
    }
  });

  const uniqueProducts = matchedProducts.filter((product) => {
    if (!product.url) return false;

    let productPath;

    try {
      productPath = new URL(product.url, window.location.origin).pathname;
    } catch (e) {
      productPath = product.url;
    }

    return !existingUrls.includes(productPath);
  });

  if (!uniqueProducts.length) return;

  /*
   * IMPORTANT:
   * Insert only into PRODUCTS.
   * Never insert into Suggestions or Pages.
   */
  let productsList = wrapper.querySelector(
    '#predictive-search-results-products-list'
  );

  /*
   * Shopify may return zero native product results for a Clone/PI search.
   * In that situation there is no Products section, so create it.
   */
  if (!productsList) {
    let productsResultGroup = wrapper.querySelector(
      '.predictive-search__custom-products-group'
    );

    if (!productsResultGroup) {
      productsResultGroup = document.createElement('div');
      productsResultGroup.className =
        'predictive-search__result-group predictive-search__custom-products-group';

      productsResultGroup.innerHTML = `
        <div>
          <h2
            id="predictive-search-products"
            class="predictive-search__heading text-body caption-with-letter-spacing"
          >
            PRODUCTS
          </h2>

          <ul
            id="predictive-search-results-products-list"
            class="predictive-search__results-list list-unstyled"
            role="group"
            aria-labelledby="predictive-search-products"
          ></ul>
        </div>
      `;

      wrapper.appendChild(productsResultGroup);
    }

    productsList = productsResultGroup.querySelector(
      '#predictive-search-results-products-list'
    );
  }

  if (!productsList) return;

  const customItemsHtml = uniqueProducts
    .map((product, index) => {
      const safeTitle = this.escapeHtml(product.title);
      const safeUrl = this.escapeHtml(product.url);
      const safeImage = this.escapeHtml(product.image);

      return `
        <li
          id="predictive-search-option-metafield-${index}"
          class="predictive-search__list-item"
          role="option"
          aria-selected="false"
        >
          <a
            href="${safeUrl}"
            class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text"
            tabindex="-1"
          >
            ${
              safeImage
                ? `
                  <img
                    class="predictive-search__image"
                    src="${safeImage}"
                    alt="${safeTitle}"
                    width="50"
                    height="50"
                  >
                `
                : ''
            }

            <div class="predictive-search__item-content predictive-search__item-content--centered">
  <p class="predictive-search__item-heading h5">
    ${safeTitle}
  </p>

  ${
    product.clone && product.clone !== 'null'
      ? `<p class="predictive-search__clone">Clone: ${this.escapeHtml(product.clone)}</p>`
      : ''
  }
</div>
          </a>
        </li>
      `;
    })
    .join('');

  productsList.insertAdjacentHTML('beforeend', customItemsHtml);
}

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');

    const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');

    if (countElement) {
      this.setLiveRegionText(countElement.textContent);
    }
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;

    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);